import React from 'react';
import type { GetFirmSettingsData } from '@seccl/client';

export interface IFirmContext {
  firmSettings: GetFirmSettingsData;
  isCustodianFirm: boolean;
}

export const FirmContext = React.createContext<IFirmContext | undefined>(undefined);

export interface IFirmProviderProps {
  /** Firm settings fetched server side, used as the initial value. */
  firmSettings: GetFirmSettingsData;
}

/**
 * Provides the firm's settings. The firm is determined by the `HostProvider`, so this must be rendered inside it.
 */
export const FirmProvider: React.FC<React.PropsWithChildren<IFirmProviderProps>> = ({ firmSettings, children }) => {
  const isCustodianFirm = React.useMemo(() => !firmSettings?.digitalCustody, [firmSettings]);

  return <FirmContext.Provider value={{ firmSettings, isCustodianFirm }}>{children}</FirmContext.Provider>;
};

export const useFirm = (): IFirmContext => {
  const context = React.useContext(FirmContext);

  if (!context) {
    throw new Error('useFirm must be used within a FirmProvider');
  }

  return context;
};
